//Reset data
export const RESET = "COMPLAINER_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "COMPLAINER_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "COMPLAINER_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "COMPLAINER_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "COMPLAINER_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "COMPLAINER_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "COMPLAINER_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "COMPLAINER_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "COMPLAINER_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "COMPLAINER_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "COMPLAINER_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "COMPLAINER_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "COMPLAINER_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "COMPLAINER_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "COMPLAINER_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "COMPLAINER_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "COMPLAINER_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "COMPLAINER_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "COMPLAINER_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "COMPLAINER_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "COMPLAINER_DEL_SET_IS_UPDATE"